import { isTournamentTracked } from "app/slices/TournamentSlice";
import { RootState } from "app/store";
import { isDataTracked, hasDataLoaded } from "app/TrackingSlice";

export const selectIsTournamentTracked = (
  state: RootState,
  tournamentId: string
) => {
  return isTournamentTracked(state.tournament.trackingDetails[tournamentId]);
};

export const selectIsTrackTracked = (state: RootState, trackId: string) => {
  return isDataTracked(state.track, trackId);
};

export const selectAllTrackedTournaments = (state: RootState) => {
  const tournamentIds = Object.keys(state.tournament.tournaments);
  return tournamentIds.filter((id) =>
    isTournamentTracked(state.tournament.trackingDetails[id])
  );
};

export const selectAllTrackedTracks = (state: RootState) => {
  const trackIds = Object.keys(state.track.trackingDetails);
  return trackIds.filter((id) => isDataTracked(state.track, id));
};

export const selectTournamentsNotTracked = (
  state: RootState,
  tournamentIds: string[]
) => {
  return tournamentIds.filter((id) => !selectIsTournamentTracked(state, id));
};

export const selectTracksNotTracked = (
  state: RootState,
  trackIds: string[]
) => {
  return trackIds.filter((id) => !selectIsTrackTracked(state, id));
};

export const selectTournamentLoaded = (
  state: RootState,
  tournamentId: string
) => {
  return state.match.tournamentsLoaded.includes(tournamentId);
};

export const selectAllInitialTournamentsLoaded = (state: RootState) => {
  return Object.keys(state.tournament.trackingDetails)
    .filter((id) => state.tournament.trackingDetails[id]?.initialLoad ?? false)
    .every((id) => selectTournamentLoaded(state, id));
};

export const selectAllTrackedTournamentsLoaded = (state: RootState) => {
  const trackedTournamentIds = selectAllTrackedTournaments(state);
  return trackedTournamentIds.every((id) => selectTournamentLoaded(state, id));
};

export const selectAllTrackedTracksLoaded = (state: RootState) => {
  const trackedTrackIds = selectAllTrackedTracks(state);
  return trackedTrackIds.every((id) => hasDataLoaded(state.track, id));
};
